import { Channel } from 'redux-saga';
import ISocketHandler from '../../../api/sockets/ISocketHandler';
import ISocketMessage from '../../../api/sockets/ISocketMessage';
import {
  WS_UPDATE_TICKET_IN_TICKET_LIST,
  ADD_TICKET_IN_TICKET_LIST,
  DELETE_TICKET_FROM_TICKET_LIST,
  WS_UPDATE_TICKETS_UNASSIGNED_QUEUE_COUNT,
} from '../../actions/tickets';
import { serializeTicket } from '../../serializers/tickets';

class TicketChannelHandler implements ISocketHandler {
  socketChannel: Channel<Record<string, unknown>>;

  constructor(channel: Channel<Record<string, unknown>>) {
    this.socketChannel = channel;
  }

  public create(message: ISocketMessage) {
    const ticket = serializeTicket(message.data);

    this.socketChannel.put({
      type: ADD_TICKET_IN_TICKET_LIST,
      payload: { ticket },
    });
  }

  public delete(message: ISocketMessage) {
    const ticket = serializeTicket(message.data);

    this.socketChannel.put({
      type: DELETE_TICKET_FROM_TICKET_LIST,
      payload: { ticketId: ticket.id },
    });
  }

  public update(payload: ISocketMessage) {
    this.socketChannel.put({
      type: WS_UPDATE_TICKET_IN_TICKET_LIST,
      payload,
    });
  }

  public info(payload: ISocketMessage): void {
    this.socketChannel.put({
      type: WS_UPDATE_TICKETS_UNASSIGNED_QUEUE_COUNT,
      payload,
    });
  }
}

export default TicketChannelHandler;
